import React from 'react';

import { Icon, Pressable } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';

import { CloseButtonWrapper } from './styled';

interface IProductDetailClose {
  onDismiss: () => void;
}

export const ProductDetailClose: React.FC<IProductDetailClose> = ({ onDismiss }) => {
  return (
    <CloseButtonWrapper>
      <Pressable onPress={onDismiss} accessibilityRole="button" accessibilityLabel={t('close')}>
        <Icon variant="cancel" />
      </Pressable>
    </CloseButtonWrapper>
  );
};
